import { MinLength, MaxLength } from "class-validator";
import {validate, validateOrReject, Contains, IsInt, Length, IsEmail, IsFQDN,
        IsDate,Min,Max } from "class-validator"; 
import {ValidateIf, IsNotEmpty,IsNumber,IsString,IsEmpty } from "class-validator"; 


export class Syskd { 
    @MaxLength(10,{message: 'COMPANY 字串太長'}) 
    @IsString({message: 'COMPANY 不是字串型態'}) 
    COMPANY: string = ""; 
  
    @MaxLength(10) 
    CREATOR: string = ""; 
  
    @MaxLength(10) 
    USR_GROUP: string = ""; 
  
    @MaxLength(8) 
    CREATE_DATE: string =""; 
  
    @MaxLength(10) 
    MODIFIER: string = ""; 
  
    @MaxLength(8) 
    MODI_DATE: string = ""; 
  
    @IsNumber() 
    @Max(999) 
    FLAG: number =0; 



    KD001: Date | undefined;            // 訊息時間 0 

    @IsNotEmpty({message: '序號 (KD002) 不可空白'}) 
    @MaxLength(4,{message: '序號 (KD002) 資料太長'})
    KD002: string = '';            // 序號 4 

    @IsNotEmpty({message: '程式代號 (KD003) 不可空白'}) 
    @MaxLength(20,{message: '程式代號 (KD003) 資料太長'})
    KD003: string = '';            // 程式代號 20 

    @IsNotEmpty({message: 'DBName (KD004) 不可空白'}) 
    @MaxLength(20,{message: 'DBName (KD004) 資料太長'})
    KD004: string = '';            // DBName 20 

    @MaxLength(10,{message: 'USERID (KD005) 資料太長'})
    KD005: string = '';            // USERID 10 

    @MaxLength(1,{message: '是否定時作業 (KD006) 資料太長'})
    KD006: string = 'N';            // 是否定時作業 1 [DEF:"N"]

    @MaxLength(300,{message: '內容 (KD007) 資料太長'})
    KD007: string = '';            // 內容 300 

    @MaxLength(15,{message: '工作電腦 (KD008) 資料太長'})
    KD008: string = '';            // 工作電腦 15 


}
